import styled from 'styled-components';

export const StyledPlayerLevelMultiplier = styled.div`
  max-width: 400px;
  position: relative;
  display: flex;

  .text-container {
    position: absolute;

    .text-center {
      position: relative;
      top: 64px;
      left: 18px;
      width: 130px;
      height: 27px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 800;
      background: linear-gradient(
        360deg,
        #ffff7f 0%,
        #ffff7f 25%,
        #ffc589 50%,
        #ffff7f 55%,
        #ffff7f 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.4));
    }
  }

  .timer {
    position: absolute;
    display: flex;
    bottom: 14px;
    left: 18px;
    width: 130px;
    color: white;
    font-size: 14px;
    justify-content: center;
    gap: 3px;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.4));

    .value {
      font-weight: 700;
    }
  }
`;
